export const messages = {
    de:{
        message:{
            hello:"Hello World"
        }
    }
}